import React from 'react';

interface IconProps {
  size?: number;
  color?: string;
}

/**
 * HttpMonitorIcon component
 * Represents HTTP/Website monitoring with a server/browser icon
 * Default size: 32x32
 */
export const HttpMonitorIcon: React.FC<IconProps> = ({ 
  size = 32, 
  color = '#101018' 
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 32 32"
    >
      <path
        fill={color}
        d="M7 22.91V18h1.227v1.636h1.637V18h1.227v4.91H9.864v-2.046H8.227v2.045zm6.136 0v-3.683H11.91V18h3.682v1.227h-1.227v3.682zm4.5 0v-3.683H16.41V18h3.682v1.227h-1.227v3.682zm3.273 0V18h2.864q.49 0 .859.368.368.369.368.86v.817q0 .492-.368.86a1.18 1.18 0 0 1-.86.368h-1.636v1.636zm1.227-2.864h1.637v-.819h-1.637z"
      />
      <path
        fill={color}
        d="M26.302 3.032c.766 0 1.5.343 2.042.952.542.61.846 1.436.846 2.298v19.5c0 .862-.304 1.689-.846 2.298-.542.61-1.276.952-2.043.952H6.08c-.766 0-1.5-.342-2.042-.952s-.847-1.436-.847-2.298v-19.5c0-.862.305-1.688.847-2.298.541-.61 1.276-.952 2.042-.952zm0 13H6.079v9.75h20.223zm0-9.75H6.079v6.5h20.223zM8.968 7.907c.383 0 .75.171 1.022.476.27.305.423.718.423 1.15 0 .43-.152.844-.423 1.148-.271.305-.639.476-1.022.476s-.75-.171-1.021-.476a1.73 1.73 0 0 1-.423-1.149c0-.43.152-.844.423-1.149.27-.305.638-.476 1.021-.476m4.334 0c.383 0 .75.171 1.02.476.272.305.424.718.424 1.15 0 .43-.152.844-.423 1.148-.271.305-.638.476-1.021.476s-.75-.171-1.022-.476a1.73 1.73 0 0 1-.423-1.149c0-.43.152-.844.423-1.149s.639-.476 1.022-.476m4.333 0c.383 0 .75.171 1.021.476s.423.718.423 1.15c0 .43-.152.844-.423 1.148-.27.305-.638.476-1.021.476s-.75-.171-1.022-.476a1.73 1.73 0 0 1-.423-1.149c0-.43.153-.844.423-1.149.271-.305.639-.476 1.022-.476"
      />
    </svg>
  );
};

